import { Inject, Injectable, InjectionToken } from '@angular/core';
import { PatientSettings } from 'estensa-module';
import { Observable, from, of } from 'rxjs';
import { CacheService } from '../../utils/cache.service';


export const ESTENSA_MODULE_PATIENT_SETTINGS_SERVICE = new InjectionToken('estensa.module.patient.settings.service');

export interface IPatientSettingsServiceNg1 {
    getAsJSON(): Promise<Partial<PatientSettings>>;
    patientSettings?: Partial<PatientSettings>;
}

export class NullPatientSettingsService {
    getAsJSON() {
        return of({});
    }
}

@Injectable({
    providedIn: 'root',
})
export class PatientSettingsService {
    constructor(
        @Inject(ESTENSA_MODULE_PATIENT_SETTINGS_SERVICE) private settingsService: IPatientSettingsServiceNg1,
        private cacheService: CacheService,
    ) {}

    getSettings(): Observable<any> {
        return this.cacheService.get('PatientSettings', from(this.settingsService.getAsJSON()));
    }

    enableAllBusinessUnitExaminationSearch() {
        return this.settingsService.patientSettings?.enableAllBusinessUnitExaminationSearch;
    }

    enableRFC249() {
        return this.settingsService.patientSettings?.enableRFC249Management;
    }

    isExternalPatientSearchingEnabled() {
        return this.settingsService.patientSettings?.isExternalPatientSearchingEnabled;
    }

    isHospitalizationPatientSearchingEnabled() {
        return this.settingsService.patientSettings?.isHospitalizationPatientSearchingEnabled;
    }

    // -------------------------------------------------------------------------
    // ADDED: Method to access secondSurnameManagement setting
    // -------------------------------------------------------------------------
    /**
     * ADDED: Double surname management feature accessor
     * When enabled AND RFC249 is NOT enabled, the search form shows:
     * - FirstSurname + SecondSurname fields (instead of single Surname field)
     * - Name field spans full width on its own row
     * @returns true if secondSurnameManagement is enabled in patient settings
     */
    secondSurnameManagement() {
        return this.settingsService.patientSettings?.secondSurnameManagement;
    }
}

